export default {
      id: "ic-euro-total-usage",
      viewBox: "0 0 26 26",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#ic-euro-total-usage",
      toString: function () {
        return this.url;
      }
    }